import React from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import PrimaryButton from "../buttons/PrimaryButton"

// Una schermata vuota non è un errore, ma senza una parola sopra sembra
// un'app rotta. Qui si dice cos'è che manca e — quando c'è qualcosa da
// fare — si offre la prima mossa invece di lasciarla cercare.
function EmptyState({ icon, title, text, actionText, action, secondaryText, secondaryAction, color }) {
	const accent = color ?? theme.colors.gunmetal
	const accentFill = color ?? theme.colors.gunmetal_fill

	return (
		<motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
			<Div d="flex" flexDir="column" align="center" textAlign="center" p="2rem 1.5rem">
				{icon && (
					<Div
						w="64px"
						h="64px"
						rounded="circle"
						bg={theme.colors.background}
						d="flex"
						align="center"
						justify="center"
						m={{ b: "1rem" }}>
						<FontAwesomeIcon icon={icon} color={accent} size="xl" />
					</Div>
				)}

				<Text textSize="subheader" textWeight="bold" m={{ b: "0.35rem" }}>
					{title}
				</Text>

				{text && (
					<Text textSize="body" textColor={theme.colors.text_light} maxW="22rem">
						{text}
					</Text>
				)}

				{actionText && action && (
					<Div m={{ t: "1.25rem" }}>
						<PrimaryButton
							m="auto"
							bg={accentFill}
							textColor="white"
							textSize="subheader"
							text={actionText}
							action={action}
						/>
					</Div>
				)}

				{secondaryText && secondaryAction && (
					<Div m={{ t: "0.75rem" }} cursor="pointer" onClick={secondaryAction}>
						<Text textSize="caption" textColor={theme.colors.primary}>
							{secondaryText}
						</Text>
					</Div>
				)}
			</Div>
		</motion.div>
	)
}

export default EmptyState
